import React from 'react';
import { rgba } from 'polished';

const Currency = ({ fill, ...props }) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill={fill ?? rgba('#FFFFFF', 0.3)}
      {...props}
    >
      <g opacity={0.3} fill="#fff">
        <path d="M27.162 25h1.377C30.447 25 32 26.57 32 28.5v2.548a.946.946 0 01-.941.952H27c.105-.298.162-.618.162-.952V25zM20.162 20h1.377A3.47 3.47 0 0125 23.472v7.584a.942.942 0 01-.941.944H20c.104-.296.162-.613.162-.944V20zM.18 9.417L6.76.379A.917.917 0 017.5 0c.292 0 .567.14.74.38l6.58 9.037a.952.952 0 01.082.98.92.92 0 01-.823.516H11.71v20.15a.93.93 0 01-.922.937H4.211a.93.93 0 01-.921-.938v-20.15H.92a.92.92 0 01-.822-.515.951.951 0 01.082-.98z" />
        <path d="M14.162 15h1.377A3.465 3.465 0 0119 18.46V31.06c0 .52-.422.941-.941.941H14a2.81 2.81 0 00.162-.941V15z" />
      </g>
    </svg>
  );
};

export default Currency;
